import React from 'react';

import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';

import { horizontalDots } from '../../assets/icon';
import ImageView from '../../components/ImageView/ImageView';

interface IOverFlowMenuViewProps {
  items: MenuProps['items'];
  icon?: React.ReactElement;
  disabled?: boolean;
  onClickFn?: () => void;
}

const OverFlowMenuView = ({
  items,
  icon,
  disabled,
}: IOverFlowMenuViewProps) => (
  <Dropdown
    disabled={disabled}
    menu={{ items }}
    trigger={['click']}
    overlayStyle={{
      maxHeight: '250px',
      overflow: 'auto',
      border: '1px solid #ccc',
      borderRadius: 10,
      minWidth: '100px',
    }}
  >
    <a
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Space>{icon || <ImageView src={horizontalDots} />}</Space>
    </a>
  </Dropdown>
);

export default OverFlowMenuView;
